// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Common, Common as This, System } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { proxySignal, ProxySignal } from "../../signals.js";

export interface validationEmail {
}

export const state_validationEmail: validationEmail = {};

setTimeout(() => {

})

